import { render, staticRenderFns } from "./TimetableTabs.vue?vue&type=template&id=d24f862c&"
import script from "./TimetableTabs.vue?vue&type=script&lang=js&"
export * from "./TimetableTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports